export default {
  'name': '@okta/okta-angular',
  'version': '2.2.1'
};
